import Vue from 'vue';
import './common/global';
import './common/lang';
import {store} from './checkout/store';
import Terms from './checkout/components/Terms';
import OrderSummary from './checkout/components/OrderSummary';
import HotelAddress from './checkout/components/HotelAddress';
import CustomerDetails from './checkout/components/CustomerDetails';
import AgencyBookingRef from './checkout/components/AgencyBookingRef';
import ProductDelivery from './checkout/components/ProductDelivery';
import BookingBtn from './checkout/components/BookingBtn';
import PaymentMethods from './payments/components/PaymentMethods';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
import {mapFields} from "vuex-map-fields";
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Install BootstrapVue
Vue.use(BootstrapVue);

import {filters} from './common/filters.js';

Vue.filter('priceFormat', filters.priceFormat);
Vue.filter('withCurrency', filters.withCurrency);

if (document.getElementById('checkout')) {
    new Vue({
        el: '#checkout',
        store,
        data: {},
        computed: {
            ...mapFields([
                'order',
            ]),
        },
        methods: {
            createBooking: function () {
                this.$refs.paymentMethods.$children.map(function (component) {
                    if (component.isActive) {
                        component.$children[0].createOrder();
                    }
                })
            },
            successBooking: function () {
                window.location.href = window.success_page;
            },
        },
        mounted() {
            if (window.order.data) {
                this.order = window.order.data;
            }
        },
        components: {
            Terms,
            ProductDelivery,
            AgencyBookingRef,
            PaymentMethods,
            CustomerDetails,
            OrderSummary,
            HotelAddress,
            BookingBtn
        }
    });
}



